module.exports = __webpack_public_path__ + "img/traffic.3105b0bd.svg";